// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Footer_footerWrapper__+vpvQ","footerNav":"Footer_footerNav__CcKox","volumeBtn":"Footer_volumeBtn__ALfIc"};